module.exports = __webpack_public_path__ + "tvicon-e2fbc1f110aa4bf79cd5.svg";